import { Link, useLocation } from "react-router-dom";
import { Home, ListOrdered, MessageSquare, User, ShieldCheck } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { cn } from "@/lib/utils";

export function BottomTabNav() {
  const { user } = useAuth();
  const loc = useLocation();
  if (!user) return null;

  const tabs =
    user.role === "admin"
      ? [
          { to: "/admin", label: "Queue", icon: ShieldCheck, id: "tab-admin" },
          { to: "/profile", label: "Profile", icon: User, id: "tab-profile" },
        ]
      : user.role === "athlete"
      ? [
          { to: "/app", label: "Home", icon: Home, id: "tab-home" },
          { to: "/bookings", label: "Bookings", icon: ListOrdered, id: "tab-bookings" },
          { to: "/messages", label: "Messages", icon: MessageSquare, id: "tab-messages" },
          { to: "/profile", label: "Profile", icon: User, id: "tab-profile" },
        ]
      : [
          { to: "/app", label: "Home", icon: Home, id: "tab-home" },
          { to: "/jobs", label: "Jobs", icon: ListOrdered, id: "tab-jobs" },
          { to: "/messages", label: "Messages", icon: MessageSquare, id: "tab-messages" },
          { to: "/profile", label: "Profile", icon: User, id: "tab-profile" },
        ];

  return (
    <nav
      className="fixed bottom-3 left-1/2 -translate-x-1/2 w-[min(560px,calc(100%-1.5rem))] rounded-2xl border border-border bg-background/90 backdrop-blur shadow-[var(--bb-shadow)]"
      style={{ zIndex: 2147483646 }}
      data-testid="bottom-tab-nav"
    >
      <ul className="grid grid-cols-4 h-[72px]" style={{ gridTemplateColumns: `repeat(${tabs.length}, minmax(0,1fr))` }}>
        {tabs.map((t) => {
          const active = loc.pathname === t.to || (t.to !== "/" && loc.pathname.startsWith(t.to));
          const Icon = t.icon;
          return (
            <li key={t.to} className="flex">
              <Link
                to={t.to}
                data-testid={t.id}
                className={cn(
                  "flex-1 flex flex-col items-center justify-center gap-1 text-[11px] font-medium rounded-xl m-1 transition-colors",
                  active
                    ? "text-primary bg-primary/10"
                    : "text-muted-foreground hover:text-foreground hover:bg-muted"
                )}
              >
                <Icon className="h-5 w-5" />
                <span>{t.label}</span>
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
